import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalButton from "../ModalButton";
import BooleanField from "../../Base/ui/inputs/BooleanField";

const CriminalHistoryListView = ({ criminalHistory, organization }) => {
  return (
    <>
      <Row>
        <BooleanField
          value={criminalHistory.involved_with_criminal_system}
          action="show"
          label="Are you currently involved with the criminal justice system"
        />
      </Row>
      <div className="d-flex justify-content-center">
        <ModalButton
          resourceName="criminalHistory"
          resource={criminalHistory}
          label="Add/Edit Criminal History"
        />
      </div>
    </>
  );
};
const mapStateToProps = (state, _) => {
  return {
    isStaffApp: state.config.isStaffApp,
    organization: state.organization,
    criminalHistory: state.criminal_history,
  };
};

export default connect(mapStateToProps, _)(CriminalHistoryListView);
